const email = {
    // not fully stricts
    // it accepts emails like:
    // .john@email.com
    // john.@email.com
    // john..doe@email.com,
    // which are not acceptable.
    full: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    partial:
        /^$|^[a-zA-Z0-9._%+-]+$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]*$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]*$/,
};

const mobile = {
    full: /^09\d{9}$/,
    partial: /^0?$|^09\d{0,9}$/,
};

const internationalPhoneNumber = {
    full: /^(\+|00|0)[1-9][0-9]{7,15}$/,
    partial:
        /^$|^\+\d{0,15}$|^0$|^00$|^0[1-9]$|^00[1-9]$|^0[1-9]\d{0,13}$|^00[1-9]\d{0,12}$/,
};

const nationalCode = {
    full: /^\d{10}$/, // more validation needed
    partial: /^\d{0,10}$/,
};

const iranianPassportNumber = {
    full: /^(?=.*[A-Za-z])(?=(?:.*\d){8})[A-Za-z\d]{9}$/,
    partial: /^(?!(?:.*[A-Za-z]){2})[A-Za-z\d]{0,9}$/,
};

const internationalPassportNumber = {
    full: /^[a-zA-Z0-9]{5,12}$/,
    partial: /^[a-zA-Z0-9]{0,12}$/,
};

export default {
    email,
    mobile,
    internationalPhoneNumber,
    nationalCode,
    iranianPassportNumber,
    internationalPassportNumber,
};
